export default __webpack_public_path__ + "static/media/cv_img_vale.7f3858a0.JPG";